// extracted by mini-css-extract-plugin
var _1 = "TableHeaderRowCell-moduleTableHeaderRowCell__zrJys";
var _2 = "TableHeaderRowCell-moduleactive__bzXzZ";
var _3 = "TableHeaderRowCell-moduleheaderText__iuvA1";
var _4 = "TableHeaderRowCell-modulepip__wuTvU";
var _5 = "TableHeaderRowCell-moduleresizing__HPleg";
var _6 = "TableHeaderRowCell-modulewithBorder__dg9XB TableCell-moduletableCellBorder__la700";
export { _1 as "TableHeaderRowCell", _2 as "active", _3 as "headerText", _4 as "pip", _5 as "resizing", _6 as "withBorder" }
